"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepLinkData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
// Sent when a session is cancelled.
exports.DeepLinkData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("deeplink"),
    link: runtypes_1.String,
    site: UUID_1.UUID,
}).And((0, runtypes_1.Partial)({
    image: runtypes_1.String,
})));
//# sourceMappingURL=DeepLinkData.js.map